export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-calendar-9531df6a8a07e239135a27c71023c3db.svg";